import { render } from "./UEWaterEditView.vue?vue&type=template&id=c746f384&scoped=true"
import script from "./UEWaterEditView.vue?vue&type=script&lang=js"
export * from "./UEWaterEditView.vue?vue&type=script&lang=js"

import "./UEWaterEditView.vue?vue&type=style&index=0&id=c746f384&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c746f384"]])

export default __exports__